export function LoadingState({ label = 'Opening the archive…' }: { label?: string }) {
  return <div className="page-state" role="status"><span className="page-state__mark">EB</span><p>{label}</p></div>;
}
export function ErrorState({ title = 'This shelf could not be opened', message }: { title?: string; message?: string }) {
  return <div className="page-state page-state--error"><span className="page-state__mark">!</span><h1>{title}</h1><p>{message || 'Please try again in a moment.'}</p></div>;
}
